import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5272fa1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-none d-lg-flex",
  "aria-label": "BARBRI Global Nav"
}
const _hoisted_2 = { class: "global-nav-top mb-0" }
const _hoisted_3 = ["aria-controls"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "For Individual Learners", -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["aria-controls"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "For Law Schools + Universities", -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "global-nav-category" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://barbri.com/law-firms-organizations-programs",
    class: "text-decoration-none"
  }, [
    /*#__PURE__*/_createElementVNode("button", { class: "drop-button" }, [
      /*#__PURE__*/_createElementVNode("span", null, "For Law Firms + Organizations")
    ])
  ])
], -1))
const _hoisted_10 = ["aria-controls"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resources", -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = ["aria-controls"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "About Us", -1))
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarItem = _resolveComponent("NavBarItem")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: "global-nav-category",
        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => ($setup.collapseDropdown($setup.IndividualLearnersMenu.htmlId)))
      }, [
        _createElementVNode("button", {
          "aria-controls": $setup.IndividualLearnersMenu.htmlId,
          "aria-expanded": "false",
          class: "drop-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleDropdown($setup.IndividualLearnersMenu.htmlId))),
          onMouseover: _cache[1] || (_cache[1] = ($event: any) => ($setup.expandDropdown($setup.IndividualLearnersMenu.htmlId)))
        }, [
          _hoisted_4,
          _createElementVNode("img", {
            alt: "",
            class: "dropdown-icon",
            src: require('~/img/global-nav-chevron.svg')
          }, null, 8, _hoisted_5)
        ], 40, _hoisted_3),
        _createVNode(_component_NavBarItem, { "nav-bar-item": $setup.IndividualLearnersMenu }, null, 8, ["nav-bar-item"])
      ], 32),
      _createElementVNode("li", {
        class: "global-nav-category",
        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => ($setup.collapseDropdown($setup.LawSchoolsUniversitiesMenu.htmlId)))
      }, [
        _createElementVNode("button", {
          "aria-controls": $setup.LawSchoolsUniversitiesMenu.htmlId,
          "aria-expanded": "false",
          class: "drop-button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleDropdown($setup.LawSchoolsUniversitiesMenu.htmlId))),
          onMouseover: _cache[4] || (_cache[4] = ($event: any) => ($setup.expandDropdown($setup.LawSchoolsUniversitiesMenu.htmlId)))
        }, [
          _hoisted_7,
          _createElementVNode("img", {
            alt: "",
            class: "dropdown-icon",
            src: require('~/img/global-nav-chevron.svg')
          }, null, 8, _hoisted_8)
        ], 40, _hoisted_6),
        _createVNode(_component_NavBarItem, { "nav-bar-item": $setup.LawSchoolsUniversitiesMenu }, null, 8, ["nav-bar-item"])
      ], 32),
      _hoisted_9,
      _createElementVNode("li", {
        class: "global-nav-category",
        onMouseleave: _cache[8] || (_cache[8] = ($event: any) => ($setup.collapseDropdown($setup.ResourcesMenu.htmlId)))
      }, [
        _createElementVNode("button", {
          "aria-controls": $setup.ResourcesMenu.htmlId,
          "aria-expanded": "false",
          class: "drop-button",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleDropdown($setup.ResourcesMenu.htmlId))),
          onMouseover: _cache[7] || (_cache[7] = ($event: any) => ($setup.expandDropdown($setup.ResourcesMenu.htmlId)))
        }, [
          _hoisted_11,
          _createElementVNode("img", {
            alt: "",
            class: "dropdown-icon",
            src: require('~/img/global-nav-chevron.svg')
          }, null, 8, _hoisted_12)
        ], 40, _hoisted_10),
        _createVNode(_component_NavBarItem, { "nav-bar-item": $setup.ResourcesMenu }, null, 8, ["nav-bar-item"])
      ], 32),
      _createElementVNode("li", {
        class: "global-nav-category",
        onMouseleave: _cache[11] || (_cache[11] = ($event: any) => ($setup.collapseDropdown($setup.AboutUsMenu.htmlId)))
      }, [
        _createElementVNode("button", {
          "aria-controls": $setup.AboutUsMenu.htmlId,
          "aria-expanded": "false",
          class: "drop-button",
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.toggleDropdown($setup.AboutUsMenu.htmlId))),
          onMouseover: _cache[10] || (_cache[10] = ($event: any) => ($setup.expandDropdown($setup.AboutUsMenu.htmlId)))
        }, [
          _hoisted_14,
          _createElementVNode("img", {
            alt: "",
            class: "dropdown-icon",
            src: require('~/img/global-nav-chevron.svg')
          }, null, 8, _hoisted_15)
        ], 40, _hoisted_13),
        _createVNode(_component_NavBarItem, { "nav-bar-item": $setup.AboutUsMenu }, null, 8, ["nav-bar-item"])
      ], 32)
    ])
  ]))
}